import { render, staticRenderFns } from "./AddCustomerComponent.vue?vue&type=template&id=6cdc9d54&"
import script from "./AddCustomerComponent.vue?vue&type=script&lang=js&"
export * from "./AddCustomerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports